<template lang="html">
  <div>
    <d-button-group class="buttons">
      <d-button size="sm" class="btn-danger" @click.prevent="confirmDeleteRow()">
        <i class="fas fa-trash"></i><span class="d-none d-lg-inline"> Deletar</span>
      </d-button>
    </d-button-group>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import { _DELETE_CUSTOMER_ } from '_modules/customer/components/CustomerModel';

export default {
  name: 'customer-buttons',
  props: {
    customer: {
      type: Object,
      default: null,
    },
  },
  components: {},
  computed: {},
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
    ]),
    confirmDeleteRow() {
      this.setToggle({ type: 'confirm_modal', bool: true });
      Events.$emit(_DELETE_CUSTOMER_, this.customer);
    },
  },
  mounted() {},
};
</script>
